import React, { Component } from "react";
import { FiCast , FiLayers , FiUsers , FiMonitor } from "react-icons/fi";

const ServiceList = [
    {
        icon: <FiCast />,
        title: 'Security Strategy',
        description: 'Let us tailor your audits based on a budget schedule.'
    },
    {
        icon: <FiLayers />,
        title: 'Dapp Audit',
        description: 'We identify vulnerabilities in applications interacting with blockchains.'
    },
    {
        icon: <FiUsers />,
        title: 'Smart contract Audit',
        description: "Find and fix vulnerabilities in your smart contract before it's too late. Lead auditor report included."
    },
    {
        icon: <FiMonitor />,
        title: 'Reporting',
        description: 'Show the world you are secure with our report being published on site.'
    }
]

class ServiceTwo extends Component{
    render(){
        let title = 'Services',
        description = 'Need an audit for you web3 project? We are here.';
        return(
            <React.Fragment>
                <div className="row">
                    <div className="col-lg-4 col-12">
                        <div className="section-title mt--30 mt_md--5 mt_mobile--5 mb_mobile--10">
                            <h2 className="title">{title}</h2>
                            <p>{description}</p>
                            <div className="service-btn">
                                <a className="btn-transparent rn-btn-dark" href="mailto:contact@dwebox.com"><span className="text">Request Custom Service</span></a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-8 col-12 mt_md--50">
                        <div className="row service-one-wrapper">
                            {ServiceList.map( (val , i) => (
                                <div className="col-lg-6 col-md-6 col-sm-6 col-12" style={{cursor:'pointer'}} key={i}>
                                    <a href="mailto:contact@dwebox.com">
                                        <div className="service service__style--2">
                                            <div className="icon">
                                                {val.icon}
                                            </div>
                                            <div className="content">
                                                <h3 className="title">{val.title}</h3>
                                                <p>{val.description}</p>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default ServiceTwo;
